import Axios, { AxiosError } from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { customMeteoKeys } from "src/query-keys";
import { APIError, CustomMeteo } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: CustomMeteo) {
  return {
    ...data,
    dateCreated: new Date(data.dateCreated),
  };
}

export function useMeteos() {
  async function queryFn(): Promise<CustomMeteo[]> {
    const response = await Axios.get("/planning-api/custommeteo");
    return response.data.map(deserialize);
  }
  return useQuery<CustomMeteo[], AxiosError<APIError>>(customMeteoKeys.all, queryFn);
}

export function useMeteoSetAsDefaultMutation(meteoId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(id: string | number): Promise<void> {
    const response = await Axios.put(`/planning-api/custommeteo/${id}/default`);
    return response.data;
  }

  return useMutation<void, AxiosError<APIError[]>, void, unknown>(() => mutationFn(meteoId), {
    onSettled: () => queryClient.invalidateQueries(customMeteoKeys.all),
  });
}

export function useMeteoDeleteMutation(meteoId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(id: string | number): Promise<void> {
    const response = await Axios.delete(`/planning-api/custommeteo/${id}`);
    return response.data;
  }

  return useMutation<void, AxiosError<APIError[]>, void, unknown>(() => mutationFn(meteoId), {
    onSettled: () => queryClient.invalidateQueries(customMeteoKeys.detail(meteoId)),
  });
}
